import styled from 'styled-components'

import typeStyle from 'styles/typeStyle'

const LABELS: Record<GQL_CardTagEnum, string> = {
  trending: 'Trending',
  new: 'New',
  popular: 'Popular',
}

export const TagPill = styled.span<{ compact?: boolean }>`
  display: inline-flex;
  align-items: center;
  width: fit-content;
  flex-shrink: 0;
  height: ${({ compact }) => (compact ? '24px' : '32px')};
  padding: ${({ compact }) => (compact ? '0 8px' : '0 12px')};

  border-radius: ${({ theme }) => theme['-ds-radius-round']};
  background-color: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  color: ${({ theme }) => theme['-ds-text-primary']};
  ${({ compact }) =>
    compact
      ? typeStyle('-ds-font-caption-sm')
      : typeStyle('-ds-font-caption-emphasised')}
  white-space: nowrap;
`

type Props = {
  tag?: GQL_CardTagEnum | null
  compact?: boolean
}

const CardTag = ({ tag, compact }: Props) => {
  if (!tag || !LABELS[tag]) return null

  return <TagPill compact={compact}>{LABELS[tag]}</TagPill>
}

export default CardTag
